const initialState = {};

export default function plpExtendedBannerReducer(state = initialState, action) {
  const { type = '', data = {} } = action || {};
  switch (type) {
    case 'GET_PLP_EXTENDED_BANNER_SUCCESS':
      return { ...state, ...data };
    default:
      return state;
  }
}
